import useFetch from '@hooks/useFetch';
import { components } from '@api/api';

export function useMyConcepts () {
    return useFetch<components['schemas']['NewItemsForSurveyModel']>({
        url: '/api/Items/GetNewItemsForSurvey',
    });
}